import { ReactNode } from "react"

interface CardProps {
    children: ReactNode
    width?: "100%" | number | undefined
    fill?: boolean
    outline?: string
    blur?: boolean
    onClick?: () => void
    maxHeight?: number
    className?: string
}

function Card(props: CardProps) {
    return (
        <div
            onClick={() => {
                if (props.onClick) props.onClick()
            }}
            style={{
                width: props.width === undefined ? "initial" : props.width,
                maxWidth: "100%",
                maxHeight: props.maxHeight,
                overflowY: props.maxHeight ? "scroll" : undefined
            }}
            className={
                "bg-white bg-opacity-80 sm:p-6 p-4 rounded-xl shadow border " +
                (props.fill ? "flex-1 " : "") +
                (props.outline ? props.outline + " " : "") +
                (props.blur !== undefined && props.blur ? "blur " : "") +
                (props.onClick ? "hover:bg-neutral-100 cursor-pointer " : "") +
                (props.className ? props.className + " " : "")
            }>
            {props.children}
        </div>
    )
}

export default Card
